module.exports = __webpack_public_path__ + "img/vide4.cb63087b.png";